export default "__VITE_ASSET__Cw9BIuGI__"